"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTaskEntity = void 0;
const react_1 = require("react");
const useTaskEntityManager_1 = require("./useTaskEntityManager");
function useGetTaskEntity(taskId, refresh = false) {
    const manager = (0, useTaskEntityManager_1.useTaskEntityManager)();
    const { find, findAsync, load } = manager;
    const taskEntity = (0, react_1.useMemo)(() => {
        return taskId ? find(taskId) : undefined;
    }, [taskId, find]);
    (0, react_1.useEffect)(() => {
        !refresh && taskId && findAsync(taskId);
    }, [refresh, taskId, findAsync]);
    // always load updated entity
    (0, react_1.useEffect)(() => {
        refresh && taskId && load(taskId);
    }, [refresh, taskId, load]);
    return { manager, taskEntity };
}
exports.useGetTaskEntity = useGetTaskEntity;
//# sourceMappingURL=useGetTaskEntity.js.map